/*
 Copyright (c) 2012, Yahoo! Inc.  All rights reserved.
 Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var path = require('path'),
    fs = require('fs'),
    pkg = JSON.parse(fs.readFileSync(path.resolve(__dirname, '..', '..', 'package.json'), 'utf8'));

module.exports = {
    NAME: pkg.name,
    VERSION: pkg.version
};




//////////////////
// WEBPACK FOOTER
// ./~/istanbul/lib/util/meta.js
// module id = 307
// module chunks = 0